import React from 'react';
import ReservationForm from '../components/ReservationForm';

const Booking = () => {
  return (
    <div style={{ position: 'relative', minHeight: '100vh', overflow: 'auto' }}>
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      >
        <source src="/videos/PavilionVid.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div style={{ position: 'relative', zIndex: 1, paddingBottom: '60px', paddingTop: '12px' }}>
        <ReservationForm />
      </div>
    </div>
  );
};

export default Booking;